<template>
  <div class="h-screen flex">
    <div style="flex: 2">
      <img
        :src="require('@/assets/images/login.png')"
        class="w-full h-full"
        fit="fill"
      />
    </div>
    <div class="p-32">
      <!-- <ul class="w-full flex justify-center">
        <img :src="require('@/assets/images/login-logo.png')" class="w-52" />
      </ul> -->
      <ul class="text-center text-3xl font-bold mt-4">
        恒路传媒会务管理系统
      </ul>
      <el-form
        ref="formDom"
        label-width="0"
        style="width: 100%"
        :model="state.model"
      >
        <el-form-item
          label=""
          prop="Account"
          :rules="[
            {
              required: true,
              message: '请输入帐号',
              trigger: 'blur',
            },
          ]"
          class="mt-12"
        >
          <el-input v-model="state.model.Account" size="large" class="h-14">
            <template #prefix><text>账号：</text></template>
          </el-input>
        </el-form-item>
        <el-form-item
          label=""
          prop="Password"
          :rules="[
            {
              required: true,
              message: '请输入密码',
              trigger: 'blur',
            },
          ]"
          class="mt-8"
        >
          <el-input
            v-model="state.model.Password"
            type="password"
            size="large"
            class="h-14"
            show-password
          >
            <template #prefix><text>密码：</text></template>
          </el-input>
        </el-form-item>
        <el-form-item
          label=""
          prop="Captcha"
          :rules="[
            {
              required: true,
              message: '请输入验证码',
              trigger: 'blur',
            },
          ]"
          class="mt-8"
        >
          <el-input
            v-model="state.model.Captcha"
            size="large"
            class="login-captcha-input h-14"
            placeholder="验证码"
          >
            <template #append>
              <div
                style="height: calc(100% - 2px); padding-top: 1px"
                class="w-36 bg-white border-l-0 mr-px"
              >
                <el-image
                  :src="state.imgModel?.image"
                  class="cursor-pointer h-full w-full"
                  @click="onLoadCaptcha()"
                  fit="fill"
                ></el-image>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item label="">
          <el-checkbox
            v-model="state.model.Save"
            label="记住账号"
            size="large"
          />
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width: 100%; height: 7vh; font-size: 18px"
            type="primary"
            @click="onSubmit"
            size="large"
          >
            登&nbsp;&nbsp;&nbsp;&nbsp;录
          </el-button>
        </el-form-item>
      </el-form>
      <div class="text-center text-gray-400 text-xs">
        © 2021 xyoa.com, Inc. 保留所有权利 皖ICP备11012359号-4
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";
import { login_captcha, login_doLogin } from "@/http/login";
import { encrypt } from "@/utils/funcs";

export default {
  setup() {
    const formDom = ref(null);
    const router = useRouter();
    const state = reactive({
      model: {},
      imgModel: {},
    });
    onMounted(() => {
      const account = localStorage.getItem("account");
      if (account) {
        state.model.Zh = account;
        state.model.Save = true;
      }

      //绑定监听事件
      window.addEventListener("keydown", keyDown);
      onLoadCaptcha();
    });

    const onLoadCaptcha = () => {
      login_captcha().then((res) => {
        if (res.status == 200) {
          state.imgModel = res.data.data;
        }
      });
    };

    onUnmounted(() => {
      //销毁事件
      window.removeEventListener("keydown", keyDown, false);
    });

    //点击回车键登录
    const keyDown = (e) => {
      if (e.keyCode == 13) {
        onSubmit();
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          // login_judge({
          //   zh: encrypt(state.model.Account),
          //   mm: encrypt(state.model.Password),
          //   yzm: state.model.Validate,
          // });
          login_doLogin({
            phone: state.model.Account,
            password: state.model.Password,
            captcha: state.model.Captcha,
            captcha_key: state.imgModel.captcha_key,
            captcha_value: state.imgModel.captcha_value,
          })
            .then((res) => {
              if (res.status == 200) {
                if (state.model.Save)
                  localStorage.setItem("account", state.model.Account);
                else localStorage.removeItem("account");
                localStorage.setItem("token", res.data?.data?.token);
                router.push("/");
              } else {
                delete state.model.Validate;
                onLoadCaptcha();
              }
            })
            .catch(() => {
              delete state.model.Validate;
              onLoadCaptcha();
            });
        }
      });
    };

    return { state, onSubmit, formDom, onLoadCaptcha, encrypt };
  },
};
</script>

<style lang="scss">
.login-captcha-input {
  .el-input-group__append {
    padding: 0 !important;
  }
}
</style>
